module.exports = __webpack_public_path__ + "static/media/TVP.52a5e735.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/TVP.png
// module id = 1085
// module chunks = 0